import { useQuery } from '@tanstack/react-query';
import { api } from '@/shared/api/client';

export type CustomMenuItem = {
  id: string;
  label: string;
  icon: string | null;
  target_type: 'url' | 'page' | 'report' | 'object';
  target_ref: string;
  parent_section: string | null;
  node: string | null;
  sort: number;
  is_active: boolean;
};

// Per-company custom menu items (Phase 2). Cached app-wide; the nav reads the
// active, top-level ones, the admin manager reads them all.
export function useCustomMenuItems() {
  const { data } = useQuery({
    queryKey: ['custom-menus'],
    queryFn: () => api.get<CustomMenuItem[]>('/custom-menus'),
  });
  return data || [];
}
